import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Interval, Timeout } from 'app/types';

import { BlackSimpleToasterService } from '../../toasters/black-simple-toaster.service';
import { VideoRoomService } from '../../video-room.service';

const NOTIFICATION_DISMISS_TIMEOUT = 7 * 1000;

export default class NetworkConnectionListener {
  private monitorInterval?: Interval;
  private notificationDismissedTimeout?: Timeout;

  private notificationInProgress = false;
  private notificationDismissed = false;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(
    private toastNotificationService: BlackSimpleToasterService,
    private videoRoomService: VideoRoomService,
  ) {}

  public init(): void {
    this.destroyed$ = new ReplaySubject(1);
    this.videoRoomService.slowNetworkConnection.pipe(takeUntil(this.destroyed$)).subscribe(this.onSlowNetwork);
  }

  private onSlowNetwork = (result: boolean) => {
    if (result) {
      this.showNotification();
      return;
    }
    if (this.notificationDismissedTimeout) {
      clearTimeout(this.notificationDismissedTimeout);
    }
    this.notificationDismissed = false; // Reset notification dismissed.
    this.closeNotification();
  };

  public end(): void {
    // Navigator Connection
    if (this.monitorInterval) {
      clearInterval(this.monitorInterval);
    }
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.closeNotification();
  }

  // ==================== [ NOTIFICATION ] ====================

  private showNotification(): void {
    // Validation
    if (this.notificationInProgress || this.notificationDismissed) {
      return;
    }

    this.notificationInProgress = true;
    this.toastNotificationService.throw('Your internet connection is unstable', 'Dismiss', () => {
      if (this.notificationDismissedTimeout) {
        clearTimeout(this.notificationDismissedTimeout);
      }
      this.notificationDismissed = true;
      this.closeNotification();
    });

    // Dismiss notification automatically after N Seconds
    this.notificationDismissedTimeout = setTimeout(() => {
      this.notificationDismissed = true;
      this.closeNotification();
    }, NOTIFICATION_DISMISS_TIMEOUT);
  }

  private closeNotification(): void {
    if (!this.notificationInProgress) {
      return;
    }

    this.notificationInProgress = false;
    this.toastNotificationService.close();
  }
}
